import React from 'react';
import type { EmojiClickData } from 'emoji-picker-react';
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react';
import { isDarkTheme } from '../../util';
import type { EmojiProps } from './EmojiPickerComp';
import { previewConfig } from './EmojiPickerComp';
import type { ISendEventResponse } from 'matrix-js-sdk';
import { useZoomBreakpoint } from '../../lib';

export type EmojiReactionsProps = Omit<
  EmojiProps & {
    reactionClick: (
      eventId: string,
      reactionKey: string,
      roomId?: string | undefined
    ) => Promise<ISendEventResponse | undefined>;
    eventId?: string;
    roomId?: string;
    /**
     * Whether the picker may move the focus into itself when it opens.
     * Must be `false` for the mobile reaction bar, which is opened by focusing
     * a message and must leave that focus (and its keyboard handling) alone.
     */
    autoFocus?: boolean;
  },
  'addMessage' | 'height'
>;

export function EmojiReactions({
  emojiData,
  reactionClick,
  eventId,
  roomId,
  autoFocus = true
}: Readonly<EmojiReactionsProps>): React.JSX.Element {
  const handleReactionClick = (emojiObject: EmojiClickData) => {
    reactionClick(eventId ?? '', emojiObject.emoji, roomId);
  };
  const zoom = useZoomBreakpoint(1.5);
  return (
    <div className={zoom ? ' zoomed-active' : ''}>
      <EmojiPicker
        theme={isDarkTheme() ? Theme.DARK : Theme.LIGHT}
        searchDisabled={true}
        autoFocusSearch={autoFocus}
        previewConfig={previewConfig}
        width={300}
        height={300}
        emojiData={emojiData}
        emojiStyle={EmojiStyle.NATIVE}
        onEmojiClick={handleReactionClick}
        skinTonesDisabled={true}
        reactionsDefaultOpen={true}
        onReactionClick={handleReactionClick}
      />
    </div>
  );
}
